export default __webpack_public_path__ + "static/Punk-a323ca6f1e1608305b9b4b31fccc5986.png";